import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { appSettings } from '../app-settings';
import { LogLevel } from '@microsoft/signalr';
import { UsersService } from './users.service';

@Injectable({
	providedIn: 'root',
})
export class SignalRService {
	private hubConnection: signalR.HubConnection;

	constructor(
        private usersService: UsersService
    ) {
    }

	// public async startConnection(){
	// 	this.hubConnection = new signalR.HubConnectionBuilder()
	// 		.withUrl(`${appSettings.SignalRHubs.Url}`, {
	// 			skipNegotiation: true,
	// 			transport: signalR.HttpTransportType.WebSockets,
	// 			accessTokenFactory: () => {
    //               return this.usersService.user.access_token;
    //             },
	// 		})
	// 		.withAutomaticReconnect()
	// 		.configureLogging(LogLevel.Debug)
	// 		.build();
	//
    //     try {
    //
    //       await this.hubConnection.start();
    //       console.log('SignalR Connection started');
    //     }catch(err) {
    //       console.log('Error establishing SignalR connection: ' + err)
    //     }
	// };

	public addMessageListener() {
		this.hubConnection.on('ReceiveMessage', (user: string, message: string) => {
			console.log(`User: ${user}, Message: ${message}`);
		});
	};

	public sendMessage(user: string, message: string){
		this.hubConnection.invoke('SendMessage', user, message).catch((err) => console.error(err));
	};
}
